import { NgFor } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

@Component({
  templateUrl: './cutting-history-error-log-dialog.component.html',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, NgFor],
})
export class CuttingHistoryErrorLogDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CuttingHistoryErrorLogDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string[]
  ) {}
}
